<script>
export default {
  name: "ZzReservationStatus2Badge",
  props: {
    statusLabel: {
      type: String,
      default: ''
    },
    statusId: {
      type: String,
      default: ''
    },
    badgeType: {
      type: String,
      default: ''
    }
  },
  methods: {
    getBackgroundColor() {
      return this.$constant.zzReservationStatus2BgColor[this.statusId] ?? '#fff3cd'
    },
    getBadgeType() {
      // FullCalendar 上で表示するときは小さめに、詳細画面では通常サイズで表示
      return this.badgeType === 'calendar' ? 'calendar-badge' : 'badge'
    },
  },
}
</script>

<template>
  <span
    v-if="statusId !== $constant.zz_reservation_status_2.unnecessary"
    :class="this.getBadgeType()"
    :style="{
      'background-color': this.getBackgroundColor(),
    }"
  >{{ statusLabel }}</span>
</template>

<style scoped lang="scss">
.badge {
  padding: 8px 16px;
  font-size: 16px;
}
.calendar-badge {
  padding: 0.4em 0.5em;
  font-size: 10px;
  border-radius: 4px;
}
</style>
